import React from "react";
import { Link } from "react-router-dom";

import { ApolloProvider } from "@apollo/client";
import client from "./../../../src/client";

import DefaultQuery from "./DefaultQuery";
import { QUERY_ROLES } from "./UserQueries";
import UserCreate from "./UserCreate";

import Heading from "components/Elements/Heading.js";

const UserCreateContainer = () => {
  return (
    <div className="container-wrapper">
      <div className="container-fluid">
        <main className="container-main">
          <Link to="/settings/users">
            {" "}
            <i className="fas fa-chevron-circle-left" /> Back
          </Link>

          <Heading size={3} className={"mb-4 mt-4"}>
            Create New User
          </Heading>

          <ApolloProvider client={client}>
            <DefaultQuery
              query={QUERY_ROLES}
              variables={{ tenantID: parseInt(localStorage.defaultTenantID) }}
            >
              {({ data: { roles } }) => <UserCreate roles={roles} />}
            </DefaultQuery>
          </ApolloProvider>
        </main>
      </div>
    </div>
  );
};

export default UserCreateContainer;
